import { Pagination, PaginationItem, Box } from "@mui/material";
import {
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const SimTablePager = () => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Box
      sx={{ display: "flex", width: "100%", justifyContent: "center", py: 2, mt: 5 }}
    >
      <Pagination
        color="primary"
        variant="outlined"
        shape="rounded"
        count={pageCount}
        page={page + 1} // DataGrid is 0-indexed
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
        // This handles the truncation logic automatically
        siblingCount={1}
        boundaryCount={1}
        renderItem={(item) => (
          <PaginationItem
            slots={{ previous: ChevronLeftIcon, next: ChevronRightIcon }}
            {...item}
            sx={{
              color: "white",
              borderColor: "rgb(33, 31, 69)",
              "&.Mui-selected": {
                backgroundColor: "rgb(2, 28, 100) !important",
                borderColor: "transparent",
                color: "rgb(1, 236, 255)",
              },
              "&:hover": {
                backgroundColor: "rgba(168, 126, 255, 0.1)",
              },
              // Style the "..." ellipsis
              "&.MuiPaginationItem-ellipsis": {
                color: "rgb(168, 126, 255)",
                border: "none",
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default SimTablePager;
